var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3526_1769)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 12,
    fill: "#333333",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 54,
    height: 54,
    rx: 11,
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7688 24.7139H32.2312C34.5886 24.7139 36.5 26.5831 36.5 28.8885V33.8254C36.5 36.1308 34.5886 38 32.2312 38H23.7688C21.4114 38 19.5 36.1308 19.5 33.8254V28.8885C19.5 26.5831 21.4114 24.7139 23.7688 24.7139ZM27.9949 33.3295C28.4928 33.3295 28.8891 32.9419 28.8891 32.455V30.2489C28.8891 29.772 28.4928 29.3844 27.9949 29.3844C27.5072 29.3844 27.1109 29.772 27.1109 30.2489V32.455C27.1109 32.9419 27.5072 33.3295 27.9949 33.3295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.522 23.396V24.8667C33.1663 24.7673 32.7904 24.7176 32.4042 24.7176H31.7437V23.396C31.7437 21.3787 30.0671 19.739 28.0044 19.739C25.9416 19.739 24.265 21.3687 24.2548 23.3761V24.7176H23.6045C23.2082 24.7176 22.8322 24.7673 22.4766 24.8766V23.396C22.4867 20.4148 24.9559 18 27.984 18C31.0528 18 33.522 20.4148 33.522 23.396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3526_1769",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3526_1769"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5bbfe0f3464fcd6c659c62b9cb577c45.svg";
export { ForwardRef as ReactComponent };